import { api } from '@/store/http-common'

const state = {
  content: {}
}

const getters = {
  getContent: state => state.content
}

const mutations = {
  setContent (state, payload) {
    state.content = payload
  }
}

const actions = {
  loadContent ({commit}) {
    api.get('ajax.php?action=sg:service.content.home.load')
      .then(response => {
        commit('setContent', response.data.data)
      })
  }
}

const homeModule = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export default homeModule



// WEBPACK FOOTER //
// ./src/store/modules/home/index.js